exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button {\n    background-color: #4CAF50;\n    border: none;\n    color: white;\n    padding: 20px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 4px 2px;\n}\n\n.button1 {border-radius: 2px;}\n.button2 {border-radius: 4px;}\n.button3 {border-radius: 8px;}\n.button4 {border-radius: 12px;}\n.button5 {border-radius: 50%;}\n\n.icon-bar {\n    width: 100%; /* Full-width */\n    background-color: #555; /* Dark-grey background */\n    overflow: auto; /* Overflow due to float */\n}\n\n.icon-bar a {\n    float: left; /* Float links side by side */\n    text-align: center; /* Center-align text */\n    width: 20%; /* Equal width (5 icons with 20% width each = 100%) */\n    padding: 12px 0; /* Some top and bottom padding */\n    transition: all 0.3s ease; /* Add transition for hover effects */\n    color: white; /* White text color */\n    font-size: 36px; /* Increased font size */\n}\n\n.icon-bar a:hover {\n    background-color: #000; /* Add a hover color */\n}\n\n.active {\n    background-color: #4CAF50; /* Add an active/current color */\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/usuario/Desktop/duran/duran-web/src/app/menu/menu.component.css
// module id = ../../../../../src/app/menu/menu.component.css
// module chunks = main